import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setSampleProducts } from '../QuickQuote/quickQuoteActions';
import SampleProducts from './SampleProducts';

function SampleProductsContainer(props) {
    return (
        <SampleProducts
            isPending={props.isPending}
            products={props.products}
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            setSampleProducts={props.setSampleProducts}
            applicationId={props.applicationId}
        />
    );
}

const mapStateToProps = state => ({
    isPending: state.quickQuoteReducer.isPending,
    products: state.quickQuoteReducer.products,
    applicationId: state.applicationIdReducer,
});

const mapDispatchToProps = dispatch => ({
    setSampleProducts: (applicationId) => {
        dispatch(setSampleProducts(applicationId));
    },
});

SampleProductsContainer.defaultProps = {
    isPending: false,
};

SampleProductsContainer.propTypes = {
    isPending: PropTypes.bool,
    products: PropTypes.array.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setSampleProducts: PropTypes.func.isRequired,
    applicationId: PropTypes.string.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SampleProductsContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SampleProducts/SampleProductsContainer.js